import AlarmsAnalyticsPage from './container'

export default AlarmsAnalyticsPage
